<!--
 * @Description: 运营总览用户消费排名组件
 * @Author: gaohc
 * @Date: 2022-07-13 09:43:52
 * @LastEditTime: 2022-11-04 13:27:28
-->
<template>
  <div class="body">
    <div class="body-header">
      <span style="font-weight: 600; color: #333333">用户消费排名Top10</span>
    </div>
    <div class="user-consumption-volume-topten">
      <div class="header">
        <el-row type="flex" class="row-bg">
          <el-col :span="4">
            <div style="text-align: center" class="grid-content bg-purple">
              排名
            </div>
          </el-col>
          <el-col :span="8">
						<div class="grid-content bg-purple">
							用户
						</div>
					</el-col>
          <el-col :span="6">
						<div style="text-align: center" class="grid-content bg-purple">
              下单次数
            </div>
					</el-col>
          <el-col :span="6">
						<div style="text-align: right" class="grid-content bg-purple">
              金额
            </div>
					</el-col>
        </el-row>
      </div>
      <div class="content">
        <el-row type="flex" v-for="(item, index) in userConsumeList" :key="index"
          class="row-bg user-consumption-volume-item">
          <el-col :span="4">
            <div style="text-align: center" class="grid-content bg-purple">
              <span :style="setTextStyle(index)" class="ranking">
								{{ index + 1 }}
							</span>
            </div>
          </el-col>
          <el-col :span="8">
						<div class="grid-content bg-purple">
							{{ item.name }}
						</div>
					</el-col>
          <el-col :span="6">
						<div style="text-align: center" class="grid-content bg-purple">
              {{ item.orderCount }}
            </div>
					</el-col>
          <el-col :span="6">
						<div style="text-align: right" class="grid-content bg-purple">
              {{ "￥" + item.amount }}
            </div>
					</el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserConsumptionRanking",
  props: ["userConsumeList"],
	
  computed: {
    //动态设置样式
    setTextStyle() {
      return function (index) {
        if (index + 1 == 1) {
          return "opacity : 1";
        } else if (index + 1 == 2) {
          return "opacity : 0.8";
        } else if (index + 1 == 3) {
          return "opacity : 0.6";
        } else {
          return "color: #333; background: transparent;";
        }
      };
    }
  }
};
</script>

<style  scoped>
.body {
  height: 440px;
  border-radius: 6px;
  border: 1px solid #d7dde5;
}

.body-header {
  display: flex;
  justify-content: space-between;
  height: 46px;
  line-height: 46px;
  padding: 0 20px;
  border-bottom: 1px solid #d7dde5;
}

.user-consumption-volume-topten {
  padding: 20px 21px;
}

.user-consumption-volume-topten .header {
  color: #333333;
  font-size: 14px;
  height: 40px;
  background: #eff5f9;
  line-height: 40px;
  text-align: left;
  padding-right: 8px;
}

.user-consumption-volume-topten .content {
  text-align: left;
  padding-right: 8px;
  color: #333333;
  font-size: 14px;
}

.user-consumption-volume-item {
  margin-top: 6px;
  border-bottom: 1px solid #eaeef5;
  height: 26px;
  line-height: 26px;
}

.ranking {
  display: inline-block;
  text-align: center;
  line-height: 15px;
  width: 17px;
  height: 15px;
  background: #fe7c4b;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  color: #f9f9f9;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/overview/components/UserConsumptionRanking.vue